import React from 'react';
import {Col, Container }  from 'react-bootstrap';


const Shops = () => {
  const slides = [{
    name: 'Princeton Soup & Sandwich Company', 
      imgSrc: './images/shopImages/IMG_3828.jpeg', 
      desc: 'Sandwich Resturant', 
      website: {
        websiteName: 'princetonsoupandsandwich.com',
        websiteLink: 'https://princetonsoupandsandwich.com/pages/cranberry',
      },
      phoneNum: '609-235-9749', 
      hoursOfOp: {
        Monday: '8 AM - 7 PM',
        Tuesday: '8 AM - 7 PM',
        Wednesday: '8 AM - 7 PM',
        Thursday: '8 AM - 7 PM',
        Friday: '8 AM - 7 PM',
        Saturday: '8 AM - 7 PM',
        Sunday: '8 AM - 6 PM'
      }
    },
    { name: 'Galleria Nails & Spa', 
      imgSrc: './images/shopImages/IMG_3829.jpeg', 
      desc: 'Nail Salon', 
      website: {
        websiteName: 'www.facebook.com/Galleria-Nails-Spa/',
        websiteLink: 'https://www.facebook.com/people/Galleria-Nails-Spa/61551482177028/ ',
      },
      phoneNum: '609-642-8910', 
      hoursOfOp: {
        Monday: '11A-7P',
        Tuesday: '11A-7P',
        Wednesday: '11A-7P',
        Thursday: '11A-7P',
        Friday: '11A-7P',
        Saturday: 'Closed',
        Sunday: 'Closed',
      }
    },
    { name: 'Lyberry Coffee Co.', 
      imgSrc: './images/shopImages/IMG_3827.jpeg', 
      desc: 'Coffee Shop', 
      website: {
        websiteName: 'lyberrycoffeeco.com ',
        websiteLink: 'https://lyberrycoffeeco.com',
      },
      phoneNum: '609-664-2022', 
      hoursOfOp: {
        Monday: '9 AM - 4 PM',
        Tuesday: '9 AM - 4 PM',
        Wednesday: '9 AM - 4 PM',
        Thursday: '9 AM - 4 PM',
        Friday: '9 AM - 4 PM',
        Saturday: '9 AM - 4 PM',
        Sunday: '9 AM - 4 PM'
      }
    },
    { name: 'AE2 Learning', 
      imgSrc: './images/shopImages/IMG_3830.jpeg', 
      desc: 'Tutoring Services', 
      website: {
        websiteName: 'ae2learning.com ',
        websiteLink: 'https://www.ae2learning.com',
      },
      phoneNum: '862-0382-2993', 
      hoursOfOp: {
        Monday: '5 PM - 8PM',
        Tuesday: '5 PM - 8PM',
        Wednesday: '5 PM - 8PM',
        Thursday: '5 PM - 8PM',
        Friday: '5 PM - 8PM',
        Saturday: '10 AM - 1 PM',
        Sunday: '10 AM - 1 PM'
      }
    },
    { name: 'Tony’s Open Kitchen by Scotto', 
      imgSrc: './images/shopImages/IMG_3831.jpeg', 
      desc: 'Italian restaurant',
      website: {
        websiteName: 'tonysopenkitchen.com',
        websiteLink: 'https://tonysopenkitchen.com',
      }, 
      phoneNum: '609-664-2077', 
      hoursOfOp: {
        Monday: 'Closed',
        Tuesday: '11 AM - 9 PM',
        Wednesday:'11 AM - 9 PM',
        Thursday: '11 AM - 9 PM',
        Friday: '11 AM - 10 PM',
        Saturday: '11 AM - 10 PM',
        Sunday: '1 PM - 9 PM'
      }
    },
    { name: "V'town", 
      imgSrc: './images/shopImages/IMG_3833.jpeg', 
      desc: 'Vietnamese Restaurant', 
      website: {
        websiteName: 'https://vtowncuisine.com',
        websiteLink: 'https://vtowncuisine.com/',
      },
      phoneNum: '609-642-9800', 
      hoursOfOp: {
        Monday: 'Closed',
        Tuesday: '11 AM - 9 PM',
        Wednesday:'11 AM - 9 PM',
        Thursday: '11 AM - 9 PM',
        Friday: '11 AM - 9 PM',
        Saturday: '11 AM - 9 PM',
        Sunday: '12 AM - 8 PM',
      }
    },
    { 
      name: "CRANBURY CONVENIENCE STORE", 
      imgSrc: './images/shopImages/IMG_3832.jpeg', 
      website: {
        websiteName: 'instagram.com/cranburyconveniencestore',
        websiteLink: 'https://www.instagram.com/cranburyconveniencestore/',
      },
      desc: 'Convenience store', 
      phoneNum: '640-229-5257', 
      hoursOfOp: {
        Monday: '9 AM - 9 PM',
        Tuesday: '9 AM - 9 PM',
        Wednesday: '9 AM - 9 PM',
        Thursday: '9 AM - 9 PM',
        Friday: '9 AM - 9 PM',
        Saturday: '9 AM - 9 PM',
        Sunday: '9 AM - 9 PM'
      }
  }];

  return (
    <Container fluid>
      <h3 className='sectionalText'>Shops</h3>
      <div className="slideShowContainerWrapper pt-3 pb-3">
      <div className="slideShowContainer">
        {[...slides, ...slides].map((slide, index) => ( // Duplicating slides
          <Container key={index} className="shopCard bg-light shadow">
            <Col sm={12} className="shopHeader">{slide.name}</Col>
            <Col sm={12} className="shopImgContainer d-flex justify-content-center">
              <img className="shopImg" src={slide.imgSrc} alt="logo" />
            </Col>
            <Col sm={12} className="shopText"> 
              <i className="bi bi-card-text"></i> {slide.desc}<br />
              <i className="bi bi-laptop"></i> <a href={slide.website.websiteLink} className="text-decoration-none shopLink" style={{color: '#444444'}}>{slide.website.websiteName}</a><br />
              <i className="bi bi-telephone"></i> {slide.phoneNum}<br />
              <i className="bi bi-clock"></i> Hours of Operation<br />
              <p className="shopHoursText">
                Monday: {slide.hoursOfOp.Monday}<br />
                Tuesday: {slide.hoursOfOp.Tuesday}<br />
                Wednesday: {slide.hoursOfOp.Wednesday}<br />
                Thursday: {slide.hoursOfOp.Thursday}<br />
                Friday: {slide.hoursOfOp.Friday}<br />
                Saturday: {slide.hoursOfOp.Saturday}<br />
                Sunday: {slide.hoursOfOp.Sunday}<br />
              </p>
            </Col>
          </Container>
        ))}
      </div>
    </div>
    </Container>
  );
};

export default Shops;




/*
import React from 'react';
import {Col, Container }  from 'react-bootstrap';


const Shops = () => {
  const slides = [{
    name: 'Princeton Soup & Sandwich Company', 
      imgSrc: './images/shopImages/IMG_3828.jpeg', 
      desc: 'Sandwich Resturant', 
      website: {
        websiteName: 'princetonsoupandsandwich.com',
        websiteLink: 'https://princetonsoupandsandwich.com/pages/cranberry',
      },
      phoneNum: '609-235-9749', 
      hoursOfOp: {
        Monday: '8 AM - 7 PM',
        Tuesday: '8 AM - 7 PM',
        Wednesday: '8 AM - 7 PM',
        Thursday: '8 AM - 7 PM',
        Friday: '8 AM - 7 PM',
        Saturday: '8 AM - 7 PM',
        Sunday: '8 AM - 6 PM'
      }
    },
    { name: 'Galleria Nails & Spa', 
      imgSrc: './images/shopImages/IMG_3829.jpeg', 
      desc: 'Nail Salon', 
      website: {
        websiteName: 'www.facebook.com/Galleria-Nails-Spa/',
        websiteLink: 'https://www.facebook.com/people/Galleria-Nails-Spa/61551482177028/ ',
      },
      phoneNum: '609-642-8910', 
      hoursOfOp: {
        Monday: '11A-7P',
        Tuesday: '11A-7P',
        Wednesday: '11A-7P',
        Thursday: '11A-7P',
        Friday: '11A-7P',
        Saturday: 'Closed',
        Sunday: 'Closed',
      }
    },
    { name: 'Lyberry Coffee Co.', 
      imgSrc: './images/shopImages/IMG_3827.jpeg', 
      desc: 'Coffee Shop', 
      website: {
        websiteName: 'lyberrycoffeeco.com ',
        websiteLink: 'https://lyberrycoffeeco.com',
      },
      phoneNum: '609-664-2022', 
      hoursOfOp: {
        Monday: '9 AM - 4 PM',
        Tuesday: '9 AM - 4 PM',
        Wednesday: '9 AM - 4 PM',
        Thursday: '9 AM - 4 PM',
        Friday: '9 AM - 4 PM',
        Saturday: '9 AM - 4 PM',
        Sunday: '9 AM - 4 PM'
      }
    },
    { name: 'AE2 Learning', 
      imgSrc: './images/shopImages/IMG_3830.jpeg', 
      desc: 'Tutoring Services', 
      website: {
        websiteName: 'ae2learning.com ',
        websiteLink: 'https://www.ae2learning.com',
      },
      phoneNum: '862-0382-2993', 
      hoursOfOp: {
        Monday: '5 PM - 8PM',
        Tuesday: '5 PM - 8PM',
        Wednesday: '5 PM - 8PM',
        Thursday: '5 PM - 8PM',
        Friday: '5 PM - 8PM',
        Saturday: '10 AM - 1 PM',
        Sunday: '10 AM - 1 PM'
      }
    },
    { name: 'Tony’s Open Kitchen by Scotto', 
      imgSrc: './images/shopImages/IMG_3831.jpeg', 
      desc: 'Italian restaurant',
      website: {
        websiteName: 'tonysopenkitchen.com',
        websiteLink: 'https://tonysopenkitchen.com',
      }, 
      phoneNum: '609-664-2077', 
      hoursOfOp: {
        Monday: 'Closed',
        Tuesday: '11 AM - 9 PM',
        Wednesday:'11 AM - 9 PM',
        Thursday: '11 AM - 9 PM',
        Friday: '11 AM - 10 PM',
        Saturday: '11 AM - 10 PM',
        Sunday: '1 PM - 9 PM'
      }
    },
    { name: "V'town", 
      imgSrc: './images/shopImages/IMG_3833.jpeg', 
      desc: 'Vietnamese Restaurant', 
      website: {
        websiteName: 'https://vtowncuisine.com',
        websiteLink: 'https://vtowncuisine.com/',
      },
      phoneNum: '609-642-9800', 
      hoursOfOp: {
        Monday: 'Closed',
        Tuesday: '11 AM - 9 PM',
        Wednesday:'11 AM - 9 PM',
        Thursday: '11 AM - 9 PM',
        Friday: '11 AM - 9 PM',
        Saturday: '11 AM - 9 PM',
        Sunday: '12 AM - 8 PM',
      }
    },
    { 
      name: "CRANBURY CONVENIENCE STORE", 
      imgSrc: './images/shopImages/IMG_3832.jpeg', 
      website: {
        websiteName: 'instagram.com/cranburyconveniencestore',
        websiteLink: 'https://www.instagram.com/cranburyconveniencestore/',
      },
      desc: 'Convenience store', 
      phoneNum: '640-229-5257', 
      hoursOfOp: {
        Monday: '9 AM - 9 PM',
        Tuesday: '9 AM - 9 PM',
        Wednesday: '9 AM - 9 PM',
        Thursday: '9 AM - 9 PM',
        Friday: '9 AM - 9 PM',
        Saturday: '9 AM - 9 PM',
        Sunday: '9 AM - 9 PM'
      }
  }];

  return (
    <div class="slideShowContainerWrapper">
      <div className='slideShowContainer' >
        {slides.map((slide, index) => (
          <Container key={index} className='shopCard bg-light shadow'>
            <Col sm={12} className = 'shopHeader'>{slide.name}</Col>
            <Col sm={12} className='shopImgContainer d-flex justify-content-center'>
              <img className='shopImg' src={slide.imgSrc} alt='logo'/>
            </Col>
            <Col sm={12} className='shopText'> 
              <i class="bi bi-card-text"></i> {slide.desc}<br></br>
              <i class="bi bi-laptop"></i> <a href= {slide.website.websiteLink} className='text-decoration-none shopLink' style={{color: '#444444'}}>{slide.website.websiteName}</a><br></br>
              <i className="bi bi-telephone"></i> {slide.phoneNum}<br></br>
              <i className="bi bi-clock"></i> Hours of Operation<br></br>
              <p className='shopHoursText'>
                Monday: {slide.hoursOfOp.Monday}<br></br>
                Tuesday: {slide.hoursOfOp.Tuesday}<br></br>
                Wednesday: {slide.hoursOfOp.Wednesday}<br></br>
                Thursday: {slide.hoursOfOp.Thursday}<br></br>
                Friday: {slide.hoursOfOp.Friday}<br></br>
                Saturday: {slide.hoursOfOp.Saturday}<br></br>
                Sunday: {slide.hoursOfOp.Sunday}<br></br> 
              </p>
            </Col>
          </Container>
        ))}
      </div>
    </div>
  );
};

export default Shops;

*/
